<template>
  <combobox
    ref="primaryInput"
    class="enum-input"
    :label="label"
    :value="selection"
    :disabled="disabled"
    :errors="errors"
    label-key="label"
    :options="options"
    :placeholder="placeholder"
    @input="onInput" />
</template>

<script>
import Combobox from '@/components/Combobox';
import Input from '@/mixins/Input';

export default {
  name: 'enum-input',
  mixins: [Input],
  components: {
    Combobox,
  },
  data() {
    return { internalValue: this.value };
  },
  computed: {
    selection() {
      return this.options.find(option => option.value === this.internalValue);
    },
  },
  props: {
    placeholder: String,
    value: String,
    options: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onInput(selection) {
      let value = null;
      if (selection) value = selection.value;
      this.internalValue = value;
      this.clearErrors();
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// EnumInput.vue?1cdad37e